import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { UserAuth } from '../../../middleware/UserContext/UserContext.middleware';
import { useTelegramAccount } from '../../hooks/useTelegramAccount';
import TelegramWizard from '../../components/TelegramWizard/TelegramWizard.component';

const TelegramAccountCreatePage: React.FC = () => {
  const { currentUser } = UserAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const {
    phone,
    otpCode,
    password,
    loading,
    error,
    step,
    accountUuid,
    setPhone,
    setOtpCode,
    setPassword,
    createAccount,
    finishAuth,
    clearError
  } = useTelegramAccount(currentUser);

  const handleSubmit = async () => {
    if (!currentUser) {
      return navigate('/login');
    }

    setIsSubmitting(true);

    try {
      await finishAuth();
      navigate('/telegram_accounts');
      message.success(t('telegram-account-created-success', { ns: 'messages' }));
    } catch (err) {
      setIsSubmitting(false);
      message.error(t('telegram-account-created-error', { ns: 'messages' }));
    }
  };

  const handleCreateAccount = async () => {
    await createAccount();
  };

  return (
    <TelegramWizard
      phone={phone}
      otpCode={otpCode}
      password={password}
      loading={loading}
      error={error}
      step={step === 'completed' || step === 'password' ? 'otp' : step}
      accountUuid={accountUuid}
      isSubmitting={isSubmitting}
      pageTitle={t('telegram-account-create-title', { ns: 'labels' })}
      submitButtonText={t('complete-setup', { ns: 'buttons' })}
      onPhoneChange={setPhone}
      onOtpChange={setOtpCode}
      onPasswordChange={setPassword}
      onCreateAccount={handleCreateAccount}
      onStartAuth={async () => {}}
      onSubmit={handleSubmit}
      onClearError={clearError}
    />
  );
};

export default TelegramAccountCreatePage;